import { ChangeDetectionStrategy, Component } from '@angular/core'
import { EventTicketGuestStepperPayload } from 'libs/shared/event-tickets/data-access/src/lib/+state/base-event-tickets.models'
import { BaseEventTicketsFacade } from 'libs/shared/event-tickets/data-access/src/lib/+state/base-event-tickets.facade'
import * as BaseEventTicketsActions from 'libs/shared/event-tickets/data-access/src/lib/+state/base-event-tickets.actions'

@Component({
  selector: 'gb-event-ticket-transfer-dialog',
  templateUrl: './gb-event-ticket-transfer-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbEventTicketTransferDialogComponent {
  selectedEventTicket$ = this.baseEventTicketsFacade.selectedEventTicket$

  constructor(private baseEventTicketsFacade: BaseEventTicketsFacade) {}

  onSubmit(stepperPayload: EventTicketGuestStepperPayload): void {
    this.baseEventTicketsFacade.dispatch(
      BaseEventTicketsActions.transferEventTicket({
        payload: {
          ...stepperPayload.profile,
          self_assign: stepperPayload.isSelfAssigned,
          custom_values: stepperPayload.customValues,
        },
      }),
    )
  }
}
